module.exports = __webpack_public_path__ + "img/control-right_old.75621ecd.svg";